import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { SharedService } from 'app/modules/common/services/shared-service';

@Component({
    selector: 'app-ordern-filter',
    templateUrl: './ordern-filter.component.html',
    styleUrls: ['./ordern-filter.component.scss'],
    standalone: false
})
export class OrdernFilterComponent implements OnInit {
    OrdenList$ = [];
    DefaultValue: string;

    @Output() OrdernChange = new EventEmitter();

    constructor(public sharedService: SharedService) {}

    ngOnInit(): void {
        this.LoadOrdernList();
    }

    LoadOrdernList(): void {
        const selectedTab = this.sharedService.selectedSelectionTabId;
        if (selectedTab === 1) {
            this.OrdenList$.push({ viewValue: 'Empresa', value: 'Empresa' });
            this.OrdenList$.push({
                viewValue: 'Trabajador',
                value: 'Trabajador',
            });
            this.DefaultValue = 'Empresa';
        } else if (selectedTab === 2) {
            this.OrdenList$.push({ viewValue: 'Empresa', value: 'Empresa' });
            this.OrdenList$.push({
                viewValue: 'Trabajador',
                value: 'Trabajador',
            });
            this.OrdenList$.push({ viewValue: 'Fecha', value: 'Fecha' });
            this.OrdenList$.push({viewValue: 'Prioritaria', value: 'Prioritaria',});
            this.OrdenList$.push({ viewValue: 'Fecha Antiguedad', value: 'FechaAntiguedad' });
            this.OrdenList$.push({ viewValue: 'Referencia', value: 'Referencia' });
            this.OrdenList$.push({ viewValue: 'Dias', value: 'Dias' });
            this.OrdenList$.push({ viewValue: 'Edad', value: 'Edad' });
            this.DefaultValue = 'Empresa';
        } else if (selectedTab === 5) {
            this.OrdenList$.push({ viewValue: 'Fecha', value: 'Fecha' });
            this.DefaultValue = 'Fecha';
        }
    }

    SelectionChange(event): void {
        if (event) {
            const selectedViewValue = event.source.selected.viewValue;
            const selectedValue = event.source.selected.value;
            const obj = { selectedValue, selectedViewValue };
            this.OrdernChange.emit(obj);
        }
    }
}
